import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useHistory } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// core components
import Button from "components/CustomButtons/Button.js";
import { infoColor } from "assets/jss/material-dashboard-pro-react.js";

import InformationPage from 'views/project/testcase/InformationPage.js';

import styles from 'views/component/Styles.js'
import ModelingPage from 'views/project/testcase/ModelingPage'
import ResultViewPage from 'views/project/testcase/ResultViewPage'
import ScenarioCopyPopup from 'views/project/testcase/ScenarioCopyPopup'

import { grayColor } from "assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles(styles);

export default function TestcaseInfo(props) {
    const { location } = props;
    const classes = useStyles();
    const history = useHistory();
    const [scenario, setScenario] = useState({});
    const [testcase, setTestcase] = useState({ name: '', simulateTime: 0, processList: [], facilityList: [], planList: [] });
    const [tabIndex, setTabIndex] = useState(-1);
    const [completed, setCompleted] = useState([false, false]);

    const [scenarioCopyPop, setScenarioCopyPop] = useState(false);

    const steps = ["공정 모델링", "결과 보기"];
    const handleStep = function (index) {
        if (index == 0 || completed[index - 1]) {
            setTabIndex(index);
        }
    }
    useEffect(() => {
        if (location.state) {
            axios.get('data/scenario/view/' + location.state.scenarioId).then(response => {
                setScenario(response.data);
            });
            axios.get('data/testcase/view/' + location.state.testcaseId).then(response => {
                setTestcase(response.data);
                if (response.data.state === 1) {
                    setCompleted([true, true]);
                    setTabIndex(1);
                } else {
                    setCompleted([false, false]);
                    setTabIndex(0);
                }
            });
        }
    }, [location]);
    const updateTestcase = function () {
        axios.get('data/testcase/view/' + location.state.testcaseId).then(response => {
            setTestcase(response.data);
            if (response.data.state === 1) {
                setCompleted([true, true]);
            } else {
                setCompleted([false, false]);
            }
        });
    };

    return (< div >
        <div hidden={tabIndex === -1}
            style={{ backgroundColor: 'white', padding: '20px 25px', borderBottom: '3px solid' + infoColor[0], marginLeft: '-15px', marginRight: '-15px' }}>
            <Button className={classes.left}
                onClick={() => history.push('../list', { 'projectId': location.state.projectId, 'scenarioId': location.state.scenarioId })} simple>시나리오 변경</Button>
            {tabIndex === steps.length - 1 ?
                <Button className={classes.right} disabled={!completed[tabIndex]}
                    onClick={e => setScenarioCopyPop(true)} color='info'>개선시나리오 생성</Button> : null
                /*<Button className={classes.right} disabled={!completed[tabIndex]}
            onClick={() => handleStep(tabIndex + 1)} color='black'>다음 단계로 이동</Button>*/}
            <div style={{ textAlign: 'center', paddingTop: '5px' }}>
                {steps.map((item, index) =>
                    <div style={{ display: 'inline-flex', alignItems: 'center' }} onClick={() => handleStep(index)} key={index}>
                        <Button round justIcon size="sm" color={tabIndex === index ? 'info' : 'gray'}
                            disabled={index !== 0 && !completed[index - 1]}>{index + 1}</Button>
                        <Button simple size="sm" color={tabIndex === index ? 'info' : 'gray'}
                            style={{ padding: '0px 10px', fontSize: '20px' }}
                            disabled={index !== 0 && !completed[index - 1]}>{item}</Button>
                        {index === steps.length - 1 ? null :
                            <ArrowForwardIosIcon htmlColor={tabIndex === index ? infoColor[0] : grayColor[0]}
                                style={{ marginRight: '30px', marginLeft: '20px' }} />}
                    </div>
                )}

            </div>
        </div>
        <ScenarioCopyPopup testcase={testcase} location={location}
            modal={scenarioCopyPop} onTestcaseChange={updateTestcase}
            onClose={() => setScenarioCopyPop(false)} />
        {tabIndex === -1 ?
            <div className={classes.center}>
                <InformationPage></InformationPage>
                <Button color="info" onClick={() => handleStep(0)}>시작하기</Button>
            </div>
            : tabIndex === 0 ?
                <div>
                    <ModelingPage testcase={testcase} scenario={scenario} onTestcaseChange={updateTestcase} show={tabIndex === 0} />
                </div>
                : tabIndex === 1 ?
                    <div>
                        <ResultViewPage testcase={testcase} testcaseId={testcase.testcaseId} />
                    </div>
                    : null}
    </div >
    );
}